import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Footer from '../../components/footer';
import { Share } from '@ifeng-fe/ui_pc_share';
import ToTop from '../../components/toTop';

/**
 * for this page
 */
import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        // console.log('layout=', this.props);
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        // 头条新闻
        const headLineNew = content.xzNews.slice(0, 1);

        content.headLineNew = headLineNew;

        const shareConfig = {
            items: ['sina', 'wechat', 'cof', 'qqzone'],
            display: 'normal',
            hover: 'hover',
            type: 'vertical',
            methods: 'hover',
            tooltip: 'left',
        };

        const shareInfo = {
            url: 'http://news.ifeng.com/xijinping/',
            title: '新改革时代：敢于啃硬骨头 敢于涉险滩_凤凰网',
            summery:
                '中共十八大向全党全国发出了深化改革开放新的宣言书、新的动员令。三年来，改革全面推进。凤凰网推出专页，记录这个新时代。',
            picUrl: 'http://p3.ifengimg.com/a/2016/0518/516c29334d81161size6_w277_h65.png',
        };

        return (
            <div className={styles.layout}>
                <Content content={content} />
                <div className={styles.side_share_box}>
                    <Share config={shareConfig} shareInfo={shareInfo} />
                </div>
                <ToTop />
                <Chip id="20036" type="struct" title="全站通用页尾导航" groupName="底部" content={content.footer}>
                    <Footer />
                </Chip>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
